import type { QueryClient } from "@tanstack/react-query";
import { TenantApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import type { GetPayJunctionResponse } from "@/openapi/generated/models";

export async function prefetchPayJunctionOptionsGet(
  tenantId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching PayJunction options");
  }

  const service = createAuthenticatedApi(TenantApi, accessToken);

  await queryClient.prefetchQuery<GetPayJunctionResponse | null>({
    queryKey: [QueryKeys.PayJunctionOptions, tenantId],
    queryFn: async () => {
      try {
        const result = await service.apiAccountTenantIdPayjunctionOptionsGet({
          tenantId,
          xTenantID: tenantId,
        });

        if (result && typeof result === 'object' && 'isSuccess' in result) {
          const wrappedResult = result as any;
          
          if (!wrappedResult.isSuccess) {
            return null;
          }

          return wrappedResult.data ?? null;
        }

        if (result && typeof result === 'object') {
          return result as GetPayJunctionResponse;
        }

        return null;
      } catch {
        return null;
      }
    },
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
